import * as types from './types'
import storage from '@/Plugins/storage'

export default () => ({
  pager: storage.session.getItem(types.STORE_PAGER)
    ? JSON.parse(storage.session.getItem(types.STORE_PAGER))
    : {
        pageSize: 10,
        orderBy: 'asc',
        sortBy: null,
        search: null,
        total: 0,
        page: 1,
        pages: 1,
      },
  isChecked: false,
  defaultComponent: {
    id: null,
    org_id: null,
    name: '',
    target: 0,
  },
  defaultMedia: {
    id: null,
    org_id: null,
    name: null,
    component_id: null,
    url: null,
    duration: 0,
    priority: null,
    start_date: null,
    end_date: null,
  },
  dashboardName: null,
  dashboardComponent: null,
  dashboardComponents: [],
  media: [],
  mediaItem: null,
  memberStatus: null,
})
